/* unplugin-vue-components disabled */import { render } from "./SearchContent.vue?vue&type=template&id=5ca97009&scoped=true&ts=true"
import script from "./SearchContent.vue?vue&type=script&lang=ts"
export * from "./SearchContent.vue?vue&type=script&lang=ts"

import "./SearchContent.vue?vue&type=style&index=0&id=5ca97009&scoped=true&lang=css"

import exportComponent from "E:\\Workspaces\\VScode\\vue3+TS\\vue案例\\cloudMusicProject-master\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ca97009"],['__file',"src/views/searchContent/SearchContent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5ca97009"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5ca97009', __exports__)) {
    console.log('reload')
    api.reload('5ca97009', __exports__)
  }
  
  module.hot.accept("./SearchContent.vue?vue&type=template&id=5ca97009&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('5ca97009', render)
  })

}


export default __exports__